// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  ticketId: __t.u64().primaryKey().name("ticket_id"),
  gameId: __t.u64().name("game_id"),
  player: __t.identity(),
  skill: __t.f32(),
  sigma: __t.f32(),
  region: __t.string(),
  partyId: __t.u64().name("party_id"),
  queuedAt: __t.timestamp().name("queued_at"),
  matched: __t.bool(),
});
